import { createContext, useState } from 'react';

export const UserContext = createContext();
export const UsersProvider = ({ children }) => {
    const [isCreatedUser, setIsCreatedUser] = useState(null);
    const [isEditedUser, setIsEditedUser] = useState(null);
    const [isDeletedUser, setIsDeletedUser] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userIds, setUserIds] = useState([]);
    
    const addUser = ( value ) => {  setIsCreatedUser(value) };
    const editUser = ( value ) => { setIsEditedUser(value) };
    const clearSuccess = () => {
        setIsCreatedUser(null);
        setIsDeletedUser(null)
        setIsEditedUser(null)
        setSelectedUser(null)
    }
    const setUser = ( User ) => { 
        setSelectedUser(User)
    }
    return (
        <UserContext.Provider value={{ 
            isCreatedUser, 
            addUser, 
            clearSuccess,

            selectedUser,
            setUser,
            
            isDeletedUser,
            setIsDeletedUser,

            isEditedUser,
            editUser,

            userIds, 
            setUserIds
            
         }}>
            {children}
        </UserContext.Provider>
    );
};
